import { I18nContext } from 'i18n'
import React, { useEffect, useState, useRef, useCallback, useContext } from 'react'
import { BsArrowRightCircle } from 'react-icons/bs'
import { StyledTypeahead, StyledClearButton } from './style'

const PaginatedDropdown = (
  { 
    source, 
    fetchOptions, 
    className,
    showRightIcon = false,
    handleIconClick,
    ...props
  }, 
  ref
) => {
  const [list, setList] = useState([])
  const [page, setPage] = useState(1)
  const [term, setTerm] = useState()
  const { translate } = useContext(I18nContext)
  // Keep track of the previous page to infer whether new results must be
  // replaces of concatenated
  const prevPageRef = useRef()
  const ownRef = useRef()
  ref = ref || ownRef

  useEffect(() => {
    if (source) {
      prevPageRef.current < page
        ? setList(list.concat(source))
        : setList(source)
    }
  }, [source])

  useEffect(() => {
    if (term) {
      fetchOptions({ term, page })
    }
  }, [page, term])

  const handlePagination = useCallback(() => {
    prevPageRef.current = page
    setPage(page + 1)
  }, [page, prevPageRef, setPage])

  const handleSearch = useCallback(text => {
    setTerm(text)
    prevPageRef.current = 1
    setPage(1)
  }, [setTerm, prevPageRef, setPage])

  const clearButton = useCallback(({ onClear, text }) => {
    function onClearAction(...args) {
      ref.current.focus()
      return onClear(...args)
    }

    return (
      <span>
        {showRightIcon && !!text?.length && (
          <BsArrowRightCircle
            color="rgba(0,0,0,0.6)"
            size={16}
            style={{ position: 'absolute', right: 30, top: 7, cursor: 'pointer' }}
            title={translate('search_input_tooltip')}
            onClick={(e) => handleIconClick && handleIconClick(text)}
          />
        )}
        <div className="rbt-aux">
          {!!text?.length && <StyledClearButton onClick={onClearAction} />}
        </div>
      </span>
    )
  }, [handleIconClick, ref, showRightIcon, translate])

  return (
    <StyledTypeahead
      id="paginated-dropdown" // Override if needed
      options={list}
      labelKey="name"
      minLength={4}
      maxResults={24}
      onPaginate={handlePagination}
      onSearch={handleSearch}
      paginate
      ref={ref}
      useCache={false}
      inputProps={{
        autoComplete: 'nope',
        className,
      }}
      flip={true}
      isRightIcon={showRightIcon}
      filterBy={() => true} // Disable local filtering
      {...props}
    >
      {clearButton}
    </StyledTypeahead>
  )
}

export default React.forwardRef(PaginatedDropdown)
